import { userConstants } from '../constants/user.constants';

const initialState = {};

export function LoanDetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOANDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.LOANDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.LOANDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}